import { of, merge } from 'rxjs';
import { mergeMap, catchError, zipAll, map } from 'rxjs/operators';

import { ModalService } from 'ui-components/services/modal-service';

import { LabelBatchStatusModal } from '../../components/modals/label-batch-status';
import { LabelBatchSubscriptionLimitError } from '../../components/modals/label-batch-status/subscription-limit';
import { getUserFriendlyMessagesForErrorResponse } from '../../errors/user-friendly-error-message-service';
import Global from '../../store/global-selectors';
import { BulkErrorsAndWarningsService } from '../../services/bulk-errors-and-warnings-service';
import * as BulkActions from '../../store/bulk/bulk.actions';
import { labelPurchasePusherRace } from '../bulk/bulk.label.observables';
import { pusherTimeout$ } from '../pusher/pusher.timeout.observable';
import * as Api from './grid/batches.grid.api';
import { labelBatchListener } from '../../services/pusher-service/persistent-listeners';
import { noop } from 'ui-components/default-props/noop';

const shipsuranceLowBalance = 'Insufficient Shipsurance Funds';
const shipsurancePurchaseError = 'Failed to purchase Shipsurance';

export const makeBatchLabelPurchaseObservable = ({ fulfillmentPlanSetId, action$, isPersonalShipsuranceAccount, getState }) => {
  const shipDate = Global.selectBatchesPurchaseShipDate(getState());
  return Api.createLabelsForBatches(fulfillmentPlanSetId, shipDate).pipe(
    mergeMap((batchData) => {
      const { labelBatchIds } = batchData;

      const allLogContext = {
        fulfillmentPlanSetId,
        labelBatchIds,
        purchasePoint: 'batch',
      };

      const timeout$ = pusherTimeout$({
        action$,
        actionTypes: [BulkActions.BULK_PROCESSING_CREATE_LABEL_MESSAGE],
        finalActionType: BulkActions.BULK_PROCESSING_CREATE_LABEL_FINAL_MESSAGE,
        timeoutMs: 120000,
        notificationFunc: noop,
        logContext: allLogContext,
      });

      const { onStart, onFinish } = labelBatchListener.createSingleJobScopedHandlers();
      onStart(labelBatchIds, allLogContext);

      return merge(
        timeout$,
        labelPurchasePusherRace({ action$, labelBatchIds, onFinish }).pipe(
          map((obj) => {
            return of(obj);
          }),
          zipAll(),
        ),
        of([{ apiSuccess: true, labelBatchIds }]),
      );
    }),
    catchError((e) => {
      const hasSubscriptionLimitError = BulkErrorsAndWarningsService.hasReceivedSubscriptionLimitError(e);
      if (hasSubscriptionLimitError) {
        ModalService.launchModal({
          component: LabelBatchStatusModal,
          props: {
            StepComponent: LabelBatchSubscriptionLimitError,
          },
        });
      }

      // Batches always shows cost review. If they reach here then they had QS + hide cost review.
      // In which case we still don't show cost review given the QS setting, but emit an action the parent observable can notify on
      const { stringErrors } = getUserFriendlyMessagesForErrorResponse(e?.response?.data);
      const shipsuranceErrorMessage = stringErrors.find((error) => {
        return error === shipsuranceLowBalance || error === shipsurancePurchaseError;
      });

      if (shipsuranceErrorMessage && !isPersonalShipsuranceAccount) {
        return of([{ apiErrorContext: { isShipsuranceBalanceLow: true } }]);
      }
      return of([{ apiErrorContext: {} }]);
    }),
  );
};
